'use client';
import "../../../styles/Home/AiFeatures/AiFeatures.css"
import { FC, useState } from 'react';
import { AiFeatureItem } from './AiFeatureItem';
import { useIntl } from "react-intl";

type Props = {};
const AiFeatures: FC<Props> = () => {
    const intl = useIntl()
    const [windowSize, setWindowSize] = useState<number>(window.innerWidth)

    window.addEventListener('resize', () => {
        setWindowSize(window.innerWidth)
    })

    return (
        <div className="p-5 px-4 px-md-5 bg-features-ai sora scroll-reveal">
            <div className={`container-feature`}>
                <div className="feature-header d-flex align-items-center justify-content-center">
                    <img
                        src={`/assets/icons/whatsapp-green.png`}
                        alt="robot"
                        width={16}
                        height={16}
                        style={{ marginBottom: '0.1rem' }}
                    />
                    <span>{intl.formatMessage({ id: 'AI.FEATURE.TAG' })}</span>
                </div>
                <div className={`${windowSize! >= 1024 && 'w-85 mx-auto'}`}>
                    <h1 className="fw-bold text-black title-feature">
                        {intl.formatMessage({ id: 'AI.FEATURE.TITLE' })}
                    </h1>
                </div>
                <div className="d-flex flex-column flex-md-row gap-5 gap-md-0 justify-content-between align-items-center">
                    <div>
                        <video loop muted autoPlay playsInline controls={false} className="video-feature">
                            <source src={`/assets/videos/ai-mockup.mp4`} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="flex-1 items-feature">
                        <div className="d-flex flex-column" style={{ gap: '16px' }}>
                            {Array.from({ length: 5 }).map((_, index) => {
                                const featureIndex = index + 1;
                                return (
                                    <AiFeatureItem
                                        key={index}
                                        id={featureIndex}
                                        title={intl.formatMessage({ id: `AI.FEATURE${featureIndex}.HEADER` })}
                                        description={intl.formatMessage({ id: `AI.FEATURE${featureIndex}.DESCRIPTION` })}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { AiFeatures };
